import utils from "@SyoLab/utils"
import { Contact, } from "@icons/appFabric/icons"
//const defaultApp = () => import(/* webpackChunkName: "DefaultApp" */"./Default.vue")
import component from "./MyTasks.vue"
const appName = 'mytasks'
const basePath = "/mytasks"
export default {
   name: appName,
   auth: true, //auth: if authenticated must have app in userApps
   menuShow: false, //menuShow overrides everything
   menuPosition: 1, //sorting menu position of app
   component: component,
   // appConfig from base -> available in Component.appConfig
   appConfig: {
      foo: 'foo'
   },
   // routes are used to match all menuItem routes
   // the are referenced to the app
   routes: [
      {
         name: "mytasks",
         path: "/mytasks/*"
      }
   ],
   menu: [
      {
         //"appName": appName, -> not needed appName is referenced on import
         "text": "Meine Tasks",
         "icon": Contact,
         "class": "defClass root",
         "route": '/mytasks', //route path
         "action": undefined, //action emitted to app
         "enabled": true, // enabled / disable menu item (can be used as function with appConfig)
         // status
         "active": false, // is active menu item
         "show": true, // show / hide, toggles visibility on click

      }
   ]
}